//Packages
import { Routes, Route, useLocation, BrowserRouter } from "react-router-dom";
import { useEffect, useState } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Helmet, HelmetProvider } from "react-helmet-async";

//Components
import Header from "./components/Header";
import Footer from "./components/Footer";

//Pages
import Home from "./pages/Home.jsx";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import PageNotFound from "./pages/PageNotFound";
import Service from "./pages/Service";

import initMagnetCursor from "./Utils/magnet-cursor.js";
import initActiveScripts, { resetMobileMenuState } from "./Utils/active.js";
import { setupMobileMenuClickOutside } from "./Utils/mobileMenuUtils.js";

function LayoutWrapper({ children, siteInfo }) {
  const location = useLocation();
  const { pathname } = location;

  const showHeader = true;
  const showFooter = true;

  useEffect(() => {
    initMagnetCursor();
    initActiveScripts();
    window.scrollTo({ top: 0, behavior: "smooth" });

    const cleanupClickOutside = setupMobileMenuClickOutside();

    const handleGlobalNavClick = (event) => {
      const target = event.target;
      if (
        target.tagName === "A" &&
        target.href &&
        !target.href.includes("#")
      ) {
        setTimeout(() => {
          resetMobileMenuState();
        }, 100);
      }
    };

    document.addEventListener("click", handleGlobalNavClick);

    return () => {
      cleanupClickOutside();
      document.removeEventListener("click", handleGlobalNavClick);
    };
  }, [pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    initMagnetCursor();
    initActiveScripts();
  }, [pathname]);

  useEffect(() => {
    const timer = setTimeout(() => {
      resetMobileMenuState();
    }, 50);

    resetMobileMenuState();

    return () => clearTimeout(timer);
  }, [pathname]);

  return (
    <>
      {showHeader && <Header siteInfo={siteInfo} />}
      {children}
      {showFooter && <Footer siteInfo={siteInfo} />}
    </>
  );
}

function App() {
  const [siteInfo, setSiteInfo] = useState(null);

  // Fetch site info
  useEffect(() => {
    fetch("https://backend.ohanyanlegal.am/688787d8ff144c502c7/api/info/site-info/")
      .then((res) => res.json())
      .then(setSiteInfo)
      .catch((err) => console.error("Failed to load site-info:", err));
  }, []);

  return (
    <HelmetProvider>
      {/* SEO + Title + Favicon */}
      {siteInfo && (
        <Helmet>
          <title>{siteInfo.site_name}</title>
          <meta
            name="description"
            content={`${siteInfo.site_name} — իրավաբանական ծառայություններ`}
          />
          <link
            rel="icon"
            type="image/png"
            href={siteInfo.icon_url || "/favicon.png"}
          />
        </Helmet>
      )}

      <BrowserRouter>
        <LayoutWrapper siteInfo={siteInfo}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/Service" element={<Service />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </LayoutWrapper>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
